import type { SVGProps } from 'react';
const DawnFlagMO = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MO_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-MO_svg__a)">
      <path fill="#079D7B" d="M0 16h22V0H0z" />
      <path
        fill="#fff"
        d="M12.482 6.933q0 .351-.048.676.12-.038.245-.072c1.397-.381 2.644-.255 2.785.281.128.485-.691 1.139-1.882 1.542-.21-.635-1.286-.827-2.581-.827-1.297 0-2.374.192-2.583.829C7.244 8.958 6.44 8.31 6.566 7.83c.14-.536 1.388-.662 2.785-.28q.11.03.217.062a5 5 0 0 1-.048-.679c0-1.472.663-2.666 1.48-2.666.819 0 1.482 1.194 1.482 2.666M8.382 9.6h.916a7 7 0 0 1-.443-.104c.168.005.376.02.614.036.43.03.96.068 1.532.068.571 0 1.1-.037 1.531-.068q.345-.025.595-.036-.233.062-.458.104h2.522q-.187.572-.495 1.067h-7.39A5 5 0 0 1 6.81 9.6zM11 12.8c1.058 0 2.03-.4 2.793-1.067H8.208A4.23 4.23 0 0 0 11 12.8"
      />
      <path
        fill="#FCD117"
        d="M11 3.2c.29 0 .524-.239.524-.533A.53.53 0 0 0 11 2.133a.53.53 0 0 0-.523.534c0 .294.234.533.523.533M6.81 5.867c.29 0 .524-.24.524-.534A.53.53 0 0 0 6.81 4.8a.53.53 0 0 0-.524.533c0 .295.235.534.524.534m8.905-.534a.53.53 0 0 1-.524.534.53.53 0 0 1-.524-.534c0-.294.235-.533.524-.533s.524.239.524.533M13.62 4.267c.289 0 .523-.24.523-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.523.533c0 .295.234.534.524.534m-4.715-.534a.53.53 0 0 1-.524.534.53.53 0 0 1-.523-.534c0-.294.234-.533.523-.533s.524.239.524.533"
      />
    </g>
  </svg>
);
export default DawnFlagMO;
